import React from "react";
import { FlexRowBetween } from "../Style";
const Names = (props) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        justifyContent: "flex-start",
      }}
    >
      <FlexRowBetween style={{ justifyContent: "center" }}>
        <div style={{ fontFamily: "rub", fontSize: "30px", fontWeight: "700" }}>
          {props.data.brideFN}
        </div>
        <div
          // className="animate__animated animate__pulse animate__infinite"   only at bs
          style={{
            zIndex: 0,
            margin: "0 13px",
            color: props.heartColor,
            fontFamily: "dar",
            fontSize: "40px",
            fontWeight: "700",
          }}
        >
          &
        </div>
        <div style={{ fontFamily: "rub", fontSize: "30px", fontWeight: "700" }}>
          {props.data.groomFN}
        </div>
      </FlexRowBetween>
      <div style={{ fontFamily: "gvR", fontSize: "30px", fontWeight: "700" }}>
        {props.data.date.replace(/T.*/, "").split("-").reverse().join("/")}
      </div>
      <div>{"״" + props.data.hall + "״," + " " + props.data.city}</div>
    </div>
  );
};

export default Names;
